
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as AppState from '../../../AppState';
import React from 'react';
import EmailInput from './EmailInput';
import TextInput from './TextInput';
import { createSavedSearchAlert } from '../../../services/saved-search-alerts/savedSearchApi';
import { toast } from 'react-toastify';
import PhoneInput from './PhoneInput';
import NumberInput from '../../Shared/MinMaxInputs/NumberInput/NumberInput';
import Checkbox from '../../Shared/Checkbox/Checkbox';
import classNames from 'classnames';
import { useRecoilValue } from 'recoil';

interface SavedSearchAlertProps {
	client: any
	dispatch: React.Dispatch<any>
	setLoading: React.Dispatch<React.SetStateAction<boolean>>
}

export const SavedSearchAlertDropdownComponent = ({
	client,
	dispatch,
	setLoading
}: SavedSearchAlertProps) => {

	const gsFilters = useRecoilValue(AppState.gsFilters);

	const handleSubmitClick = () => {
		if (!client.marketingOptIn)
			return;

		if (client.name === '') {
			return toast.error('Please provide a name for your subscription.',
				{
					icon: <FontAwesomeIcon icon={['fas', 'exclamation-triangle']} />,
					toastId: 'errorSubmittingSavedSearchAlert-name',
					containerId: 'filterWarningToastContainer',
					theme: 'light',
				}
			);
		}

		if (client.email === '') {
			return toast.error('Please provide an email for your subscription.',
				{
					icon: <FontAwesomeIcon icon={['fas', 'exclamation-triangle']} />,
					toastId: 'errorSubmittingSavedSearchAlert-email',
					containerId: 'filterWarningToastContainer',
					theme: 'light',
				}
			);
		} else if (!client.email.includes('@') || !client.email.includes('.')) {
			return toast.error('Please provide a valid email address.',
				{
					icon: <FontAwesomeIcon icon={['fas', 'exclamation-triangle']} />,
					toastId: 'errorSubmittingSavedSearchAlert-invalid-email',
					containerId: 'filterWarningToastContainer',
					theme: 'light',
				}
			);
		}

		if (client.phone === '') {
			return toast.error('Please provide a phone number.',
				{
					icon: <FontAwesomeIcon icon={['fas', 'exclamation-triangle']} />,
					toastId: 'errorSubmittingSavedSearchAlert-phone',
					containerId: 'filterWarningToastContainer',
					theme: 'light',
				}
			);
		}

		setLoading(true);
		toast.promise(
			createSavedSearchAlert(client.name, client.email, client.phone.replace(/\s/g, ''), client.zip, gsFilters),
			{
				pending: {
					icon: <FontAwesomeIcon icon={['far', 'spinner']} className=' cc-btn__icon cc-btn__icon--prefix spinner' />,
					render: 'Submitting subscription...'
				},
				success: {
					icon: < FontAwesomeIcon icon={['far', 'face-smile-plus']} />,
					render: 'Subscription submitted!'
				},
				error: {
					icon: <FontAwesomeIcon icon={['fas', 'exclamation-triangle']} />,
					render: 'Error submitting subscription.',
				}
			},
			{
				toastId: 'successSubmittingSavedSearchAlert',
				containerId: 'filterWarningToastContainer',
				theme: 'light'
			}
		).then(() => {
			dispatch({ type: 'clearInformation' });
		}
		)
			.catch((err) => console.error(err))
			.finally(() => setLoading(false));

	};

	return <div className='saved-search-alert--dropdown'>
		<h2>Stay up to date</h2>
		<p>Sign-up to see recent real estate listings and sales in your local market</p>
		<TextInput
			label='Full Name: '
			className='w-100 form-control'
			id='saved-search-alert-client-name-input'
			value={client.name}
			onChange={(value) => dispatch({ type: 'setName', value: value })}
		/>
		<EmailInput
			label='Email: '
			className='w-100 form-control'
			id='saved-search-alert-client-email-input'
			value={client.email}
			onChange={(value) => dispatch({ type: 'setEmail', value: value })}
		/>
		<PhoneInput
			label='Phone: '
			className='w-100 form-control'
			id='saved-search-alert-client-phone-input'
			value={client.phone}
			onChange={(value) => dispatch({ type: 'setPhone', value: value })}
		/>
		<NumberInput
			id='saved-search-alert-client-zip-input'
			label='Zip: '
			className='w-100 form-control'
			value={client.zip}
			onChange={(value) => dispatch({ type: 'setZip', value: value })}
			maxLength={5}
		/>
		<Checkbox
			id='saved-search-alert-client-marketing-opt-in-checkbox'
			name='marketing-opt-in'
			label='I opt-in to receiving promotional communications from CapCenter including emails, phone calls, and text messages'
			labelClassName='saved-search-alert--dropdown-checkbox-label'
			checkedValue={client.marketingOptIn}
			onCheckedChange={(value) => dispatch({ type: 'setOptIn', value: value })}
		/>
		<button className={'cc-btn cc-btn--lg cc-btn--filled cc-btn--primary cc-btn--reset-text cc-btn--navbar mt-4 mx-0 d-flex w-100 saved-search-alert--submit-button ' + classNames({ disabled: !client.marketingOptIn })}
			onClick={() => {
				handleSubmitClick();
			}}
		>
			Subscribe
			<FontAwesomeIcon icon={['far', 'send']} className='m-0 mx-2 p-0 cc-btn__icon cc-btn__icon--prefix' />
		</button>

	</div>;
};